import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { SwPush } from '@angular/service-worker';
import { envs } from '@envs/environment';

@Injectable({
  providedIn: 'root',
})
export class PushNotificationService {
  private swPush = inject(SwPush);
  private readonly httpClient = inject(HttpClient);
  private subConfig: Record<string, any> | null = null;

  requestSub() {
    if (!this.swPush.isEnabled) {
      throw new Error('Push notifications are not enabled');
    } else {
      this.httpClient.get(envs.apiUrl + '/push/vapid-public-key').subscribe({
        next: (res) => {
          Notification.requestPermission().then(() => {
            this.swPush
              .requestSubscription({
                serverPublicKey: (res as any).publicKey,
              })
              .then((sub) => {
                const jsonSub = sub.toJSON();
                this.subConfig = jsonSub;
                this.httpClient.post(envs.apiUrl + '/push/subscribe', jsonSub).subscribe({
                  next: (res) => {
                    localStorage.setItem('swPush-sid', (res as any).subscriptionId);
                  },
                });
              });
          });
        },
      });
    }
  }

  unsubscribe() {
    this.httpClient
      .delete(envs.apiUrl + '/push/unsubscribe', {
        body: { endpoint: this.subConfig?.['endpoint'] },
      })
      .subscribe({
        next: (res) => {
          console.log(res);
          localStorage.removeItem('swPush-sid');
          this.swPush.unsubscribe();
        },
      });
  }

  subscribeForNotifications() {
    this.swPush.notificationClicks.subscribe({
      next: (res) => {
        console.log(res);
      },
    });
    this.swPush.messages.subscribe({
      next: (res) => {
        console.log(res);
      },
    });
  }
}
